import React from 'react'
import { connect } from 'react-redux'
import { utilsFunction } from '../../../helpers/functions/utilsFunction';
import { getInitState, getSafe } from '@/helpers/global';
import { settingConfigs } from '../../../configurations';

const initStateFunc = getInitState({
  TTLBindingSettleMethodT: 'fund_management_transfer',
  TTLBindingSettleMethodL: 'fund_chats',
  SCBBindingSettleMethodT: 'fund_management_transfer',
  SCBBindingSettleMethodL: 'fund_chats',
  EIFBindingSettleMethodT: 'fund_management_local_transfer',
  EIFBindingSettleMethodL: 'fund_management_local_transfer',
  CMBIBindingSettleMethodT: 'fund_management_transfer',
  CMBIBindingSettleMethodL: 'fund_chats',
  BASICBindingSettleMethodT: 'fund_management_transfer',
  BASICBindingSettleMethodL: 'fund_chats',
  FUBONBindingSettleMethodT: 'fund_management_transfer',
  FUBONBindingSettleMethodL: 'fund_chats',
})

class FundCellRender extends React.Component {
  render() {
    return this.renderContent()
  }
  bindingTransactionType(value) {
    switch (value) {
      case 'D': return 'fund_deposit';
      case 'W': return 'fund_withdrawal';
      default: return '-';
    }
  }
  bindingStatus(value) {
    switch (value) {
      case 'C': return 'fund_status_cancelled';
      case 'P': return 'fund_status_pending';
      case 'R': return 'fund_status_received';
      case 'A': return 'fund_status_approved';
      case 'X': return 'fund_status_rejected';
      case 'D': return 'fund_status_removed';
      default: return '-';
    }
  }
  renderTransactionType() {
    const { data, language } = this.props;
    const key = this.bindingTransactionType(data.transactionType);
    return (
      <div>
        <span>{language[key] ? language[key] : key}</span>
      </div>
    )
  }

  renderStatus() {
    const {data, language} = this.props;
    const key = this.bindingStatus(data.status);
    return (
      <div>
        <span>{language[key] ? language[key] : key}</span>
      </div>
    )
  }

  bindingSettleMethod(value) {
    switch (value) {
      case 'Q': return 'fund_cheque';
      case 'C': return 'fund_cash';
      case 'T': return  initStateFunc('TTLBindingSettleMethodT');
      case 'R': return 'fund_management_overseas_transfer';
      case 'O': return 'fund_transfer';
      case 'B': return 'fund_transfer';
      case 'S': return 'fund_cheque_pick_up';
      case 'I': return 'fund_bank_in';
      case 'L': return  initStateFunc('TTLBindingSettleMethodL');
      case 'U': return 'fund_management_overseas_transfer';
      case 'E': return 'fund_management_bank_transfer';
      case 'Z': return 'fund_management_bank_transfer';
      case 'D': return 'fund_management_eddi';
      case 'H': return 'fund_management_fps';
      default: return '-';
    }
  }

  renderSettleMethod() {
    const { data, language } = this.props;
    const key = this.bindingSettleMethod(data.settleMethod);
    return (
      <div>
        <span>{language[key] ? language[key] : key}</span>
      </div>
    )
  }
  bindingFundChannel(value) {
    switch (value) {
      case 'INT': return 'fund_internet';
      case 'MAU': return 'fund_customer_service_officer';
      default: return '-';
    }
  }

  renderFundChannel() {
    const { data, language } = this.props;
    const key = this.bindingFundChannel(data.channelID);
    return (
      <div>
        <span>{language[key] ? language[key] : key}</span>
      </div>
    )
  }

  renderFundAmount(){
    const { data, language, value,colDef } = this.props;
    const key = this.bindingFundChannel(data.channelID);
    return (
      <div style={{textAlign:'right'}}>
        <span>{this.getAmount()}</span>
      </div>
    )
  }

  getAmount(){
    let {value} = this.props;
    value = getSafe(() => utilsFunction.formatNumber(
      value,
      settingConfigs.QUANTITY.decimal,
      settingConfigs.QUANTITY.decimalSeparator,
      settingConfigs.QUANTITY.thousandSeparator)
      , value);
    if(value === 0){
      value = '-'
    }
    return value;
  }

  renderContent() {
    const { colDef } = this.props;
    switch (colDef.colId) {
      case 'fund_transaction_type': return this.renderTransactionType();
      case 'fund_settle_method': return this.renderSettleMethod();
      case 'fund_channel': return this.renderFundChannel();
      case 'fund_to_amount': return this.renderFundAmount();
      case 'fund_from_amount': return this.renderFundAmount();
      case 'fund_status': return this.renderStatus();
      default: break;
    }
  }
}

export default connect(
  state => ({
    language: state.app.language
  })
)(FundCellRender)
